(function () {
  function init(root) {
    if (!root || root.dataset.thyredFbReady === '1') return;
    root.dataset.thyredFbReady = '1';

    var clip = root.querySelector('[data-fb-clip]');
    var bar = root.querySelector('[data-fb-bar]');
    var frontTag = root.querySelector('[data-fb-tag-front]');
    var backTag = root.querySelector('[data-fb-tag-back]');
    var pos = 50;
    var dragging = false;

    function apply() {
      if (clip) clip.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      if (bar) bar.style.left = pos + '%';
      if (frontTag) {
        frontTag.style.opacity = pos > 2 ? 1 : 0;
        frontTag.style.pointerEvents = pos > 2 ? 'auto' : 'none';
      }
      if (backTag) {
        backTag.style.opacity = pos < 98 ? 1 : 0;
        backTag.style.pointerEvents = pos < 98 ? 'auto' : 'none';
      }
    }

    function updateFromX(clientX) {
      var r = root.getBoundingClientRect();
      var p = ((clientX - r.left) / r.width) * 100;
      pos = Math.max(0, Math.min(100, p));
      apply();
    }

    function start(e) {
      dragging = true;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      updateFromX(x);
      e.preventDefault();
    }
    function move(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      updateFromX(x);
    }
    function end() { dragging = false; }

    root.addEventListener('mousedown', start);
    root.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);

    apply();
  }
  function boot() {
    document.querySelectorAll('[data-thyred-frontback]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
